import { render, staticRenderFns } from "./my-bread.vue?vue&type=template&id=37a03ab7&scoped=true&"
import script from "./my-bread.vue?vue&type=script&lang=js&"
export * from "./my-bread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a03ab7",
  null
  
)

export default component.exports